import React, { useState } from 'react';

import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const AccountSettingsForm = ({ initialData, onSave }) => {
  const [formData, setFormData] = useState(initialData);
  const [isEditing, setIsEditing] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const handleChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSave = async () => {
    setIsSaving(true);
    await onSave(formData);
    setIsSaving(false);
    setIsEditing(false);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-foreground">Informations personnelles</h3>
        {!isEditing ? (
          <Button
            variant="outline"
            size="sm"
            iconName="Edit2"
            iconPosition="left"
            onClick={() => setIsEditing(true)}
          >
            Modifier
          </Button>
        ) : (
          <div className="flex gap-2">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => {
                setFormData(initialData);
                setIsEditing(false);
              }}
            >
              Annuler
            </Button>
            <Button
              variant="default"
              size="sm"
              iconName="Save"
              iconPosition="left"
              loading={isSaving}
              onClick={handleSave}
            >
              Enregistrer
            </Button>
          </div>
        )}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <Input
          label="Prénom"
          type="text"
          value={formData?.firstName}
          onChange={(e) => handleChange('firstName', e?.target?.value)}
          disabled={!isEditing}
          required
        />
        <Input
          label="Nom"
          type="text"
          value={formData?.lastName}
          onChange={(e) => handleChange('lastName', e?.target?.value)}
          disabled={!isEditing}
          required
        />
      </div>
      <Input
        label="Email"
        type="email"
        value={formData?.email}
        onChange={(e) => handleChange('email', e?.target?.value)}
        disabled={!isEditing}
        description="Utilisé pour les notifications et la connexion"
        required
      />
      <Input
        label="Téléphone"
        type="tel"
        value={formData?.phone}
        onChange={(e) => handleChange('phone', e?.target?.value)}
        disabled={!isEditing}
        description="Pour les communications urgentes"
        required
      />
      <div className="pt-6 border-t border-border">
        <h3 className="text-lg font-semibold text-foreground mb-4">Adresse principale</h3>
        <div className="space-y-4">
          <Input
            label="Adresse"
            type="text"
            value={formData?.address}
            onChange={(e) => handleChange('address', e?.target?.value)}
            disabled={!isEditing}
            required
          />
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
            <Input
              label="Code postal"
              type="text"
              value={formData?.postalCode}
              onChange={(e) => handleChange('postalCode', e?.target?.value)}
              disabled={!isEditing}
              required
            />
            <Input
              label="Ville"
              type="text"
              value={formData?.city}
              onChange={(e) => handleChange('city', e?.target?.value)}
              disabled={!isEditing}
              required
              className="lg:col-span-2"
            />
          </div>
        </div>
      </div>
      <div className="pt-6 border-t border-border">
        <h3 className="text-lg font-semibold text-foreground mb-4">Préférences de notification</h3>
        <div className="space-y-3">
          <Checkbox
            label="Notifications par email"
            description="Recevoir les confirmations et rappels par email"
            checked={formData?.emailNotifications}
            onChange={(e) => handleChange('emailNotifications', e?.target?.checked)}
            disabled={!isEditing}
          />
          <Checkbox
            label="Notifications par SMS"
            description="Recevoir les alertes urgentes par SMS"
            checked={formData?.smsNotifications}
            onChange={(e) => handleChange('smsNotifications', e?.target?.checked)}
            disabled={!isEditing}
          />
          <Checkbox
            label="Rappels automatiques"
            description="Recevoir des rappels avant les interventions"
            checked={formData?.autoReminders}
            onChange={(e) => handleChange('autoReminders', e?.target?.checked)}
            disabled={!isEditing}
          />
          <Checkbox
            label="Offres promotionnelles"
            description="Recevoir les offres spéciales et promotions"
            checked={formData?.promotionalEmails}
            onChange={(e) => handleChange('promotionalEmails', e?.target?.checked)}
            disabled={!isEditing}
          />
        </div>
      </div>
    </div>
  );
};

export default AccountSettingsForm;